import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "💰", key: "tooExpensive" },
  { emoji: "🧩", key: "tooComplicated" },
  { emoji: "🎨", key: "noRightStyle" },
  { emoji: "🤷", key: "neverGotAround" },
]

export default function PetsBlockerPage() {
  return <RadioCardListPage translationKey="petsBlocker" options={OPTIONS} />
}
